
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./components/HomePage";
import Men from "./pages/Men";
import Women from "./pages/Women";
import Kids from "./pages/Kids";
import Jordan from "./pages/Jordan";
import Sport from "./pages/Sport";
import New from "./pages/New";
import SignIn from "./pages/SignPage";
import Help from "./pages/Help";
import ProductPage from "./pages/ProductPage";
import Footer from "./components/Footer";
import CheckoutPage from "./pages/CheckoutPage";
import { CartProvider } from "./pages/CartContext";
import PaymentPage from "./pages/PaymentPage";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ConfirmationPage from "./pages/ConfirmationPage"; 
import AboutPage from "./pages/AboutPage";
import FeedbackPage from "./pages/FeedbackPage";
import AdminDashboard from "./pages/AdminDashboard";


// const stripePromise = loadStripe("pk_test_51RRauGJKK4tbvpBXo9gqcUoW7IEilSmgzxuVnYJSBSPHL1PeD9ugYK8ynsaHy6QeLKrN6phbTm1bfLmMhhVheCBE00sgbjwqWB");
const stripePromise = loadStripe("pk_live_51RRauGJKK4tbvpBXXeb8msP4RTaIC2XiwnY8Ogc8LOsUyY9JjHNtIZTM7suJukyUVTUoh8IL5ewY77un3VXgAPej00tqbVo16l");

function App() {
  return (
    <CartProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/new" element={<New />} />
          <Route path="/men" element={<Men />} />
          <Route path="/women" element={<Women />} />
          <Route path="/kids" element={<Kids />} />
          <Route path="/jordan" element={<Jordan />} />
          <Route path="/sport" element={<Sport />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/help" element={<Help />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          
          <Route
            path="/payment"
            element={
              <Elements stripe={stripePromise}>
                <PaymentPage />
              </Elements>
            }
          />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;

